/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import * as constants from "../../constants/teaserList";
import { Teaser } from "../../records/teaser_list";
import { CLOSE_POPUP } from "../../constants";
import { ON_LOAD_CONFIG } from "../../constants/config";

function isOpen(state = false, action) {
  if (
    action.type == constants.OPEN_TEASER_FORM_ADD ||
    action.type == constants.OPEN_TEASER_FORM_EDIT
  ) {
    return true;
  }
  if (action.type == CLOSE_POPUP) {
    return false;
  }
  return state;
}

function errors(state = {}, action) {
  if (action.type == constants.ON_TEASER_FORM_SAVE_FAILED) {
    return action.errors;
  }
  if (action.type == CLOSE_POPUP) {
    return {};
  }
  return state;
}

function tmpImgErrors(state = [], action) {
  if (action.type == constants.ON_TEASER_TMP_IMAGE_UPLOAD_FAILED) {
    return action.errors.image;
  }
  if (action.type == constants.ON_TEASER_TMP_IMAGE_UPLOAD_SUCCESS) {
    return [];
  }
  return state;
}

function teaser(state = new Teaser(), action) {
  if (action.type == constants.OPEN_TEASER_FORM_EDIT) {
    return new Teaser({ id: action.id });
  }
  if (action.type == constants.ON_LOAD_TEASER_SUCCESS) {
    return new Teaser(action.teaser);
  }
  if (
    action.type == constants.OPEN_TEASER_FORM_ADD ||
    action.type == constants.CLOSE_TEASER_FORM
  ) {
    return new Teaser({ cid: action.cid });
  }
  if (action.type == constants.SET_TEASER_FORM_FIELD) {
    return state.merge(action.payload);
  }
  if (action.type == constants.ON_TEASER_TMP_IMAGE_UPLOAD_SUCCESS) {
    return state.set("image", action.image);
  }
  return state;
}

const defaultCpc = {
  min: 0,
  campaign: 0
};

function cpc(state = defaultCpc, action) {
  if (action.type === ON_LOAD_CONFIG && action.payload.MIN_CPC) {
    return {
      ...state,
      min: action.payload.MIN_CPC
    };
  }
  if (action.type == constants.SET_TEASER_MIN_CPC) {
    return action.cpc;
  }
  return state;
}

export default combineReducers({
  isOpen,
  errors,
  teaser,
  tmpImgErrors,
  cpc
});
